/*
 * Peel Solo — the Solo New York page: the best-seller tabs, and the
 * scroll reveal the bands below the fold fade up with.
 *
 * The tabs swap which panel is shown. Every panel is already in the page
 * — Liquid rendered them all — so this file only moves the `hidden`
 * attribute and the selected state around: nothing is fetched, and if
 * the file never arrives the first tab's products are simply the band.
 *
 * The reveal depends on peel-common.js (peelInitScrollReveal) being
 * loaded first, which is what gates it. The hero is left out: it is
 * above the fold, and fading in the first thing on the page reads as a
 * slow load rather than as a reveal.
 */
(function () {
  function initTabs(scope) {
    var tabs = [].slice.call(scope.querySelectorAll('[data-peel-solo-tab]'));
    if (tabs.length < 2) return;

    function select(tab) {
      tabs.forEach(function (other) {
        var panel = document.getElementById(other.getAttribute('data-peel-solo-tab'));
        var on = other === tab;
        other.classList.toggle('is-active', on);
        other.setAttribute('aria-selected', on ? 'true' : 'false');
        /* Only the selected tab stays in the tab order, so the arrow keys
           below are how the strip is walked — which is what a tablist
           is meant to do. */
        other.setAttribute('tabindex', on ? '0' : '-1');
        if (panel) panel.hidden = !on;
      });
    }

    tabs.forEach(function (tab, index) {
      tab.setAttribute('tabindex', tab.getAttribute('aria-selected') === 'true' ? '0' : '-1');

      tab.addEventListener('click', function () {
        select(tab);
      });

      tab.addEventListener('keydown', function (event) {
        var step = 0;
        if (event.key === 'ArrowRight') step = 1;
        if (event.key === 'ArrowLeft') step = -1;
        if (!step) return;
        event.preventDefault();
        var next = tabs[(index + step + tabs.length) % tabs.length];
        select(next);
        next.focus();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    [].slice.call(document.querySelectorAll('[data-peel-solo-tabs]')).forEach(initTabs);

    if (typeof window.peelInitScrollReveal !== 'function') return;
    window.peelInitScrollReveal([
      '.peel-solo-cats-outer',
      '.peel-solo-split-outer',
      '.peel-solo-press-outer',
      '.peel-solo-best-outer',
      '.peel-solo-features-outer',
      '.peel-solo-banner-outer'
    ]);
  });
})();
